/**
 * Pack Size Selector for Product Cards
 * Handles pack switching on product cards without page reload.
 * Reads embedded JSON data and updates price display + variant ID.
 */
(function () {
  'use strict';

  /**
   * Format cents to money string (e.g., 5400 -> "$54.00")
   */
  function formatMoney(cents) {
    var dollars = (cents / 100).toFixed(2);
    return '$' + dollars;
  }

  /**
   * Initialize a single pack card
   */
  function initPackCard(cardEl) {
    var jsonEl = cardEl.querySelector('.pack-card__data');
    if (!jsonEl) return;

    var packData;
    try {
      packData = JSON.parse(jsonEl.textContent);
    } catch (e) {
      console.error('Pack selector: invalid JSON data', e);
      return;
    }

    // Build a lookup map: packSize -> data object
    var packMap = {};
    packData.forEach(function (item) {
      packMap[item.packSize] = item;
    });

    var radios = cardEl.querySelectorAll('.pack-card__radio');
    var promoEl = cardEl.querySelector('[data-pack-promo]');
    var variantInput = cardEl.querySelector('[data-pack-variant-input]');
    var submitButton = cardEl.querySelector('.quick-add__submit');
    var addToCartSpan = submitButton ? submitButton.querySelector('span:not(.sold-out-message):not(.loading__spinner)') : null;
    var soldOutSpan = submitButton ? submitButton.querySelector('.sold-out-message') : null;

    // Find the card's main product image for swapping
    var cardMediaEl = cardEl.querySelector('.card__media .media img:first-child');

    // Populate price info on each radio row
    radios.forEach(function (radio) {
      var size = parseInt(radio.getAttribute('data-pack-size'));
      var priceEl = radio.querySelector('[data-radio-price]');
      var data = packMap[size];
      if (data && priceEl) {
        var perBag = formatMoney(data.price / size);
        var total = formatMoney(data.price);
        priceEl.textContent = '(' + perBag + '/bag)';
      }
    });

    /**
     * Update the card UI for a given pack size
     */
    function selectPack(size) {
      var data = packMap[size];

      // Update active radio (always highlight, even without data)
      radios.forEach(function (radio) {
        var radioSize = parseInt(radio.getAttribute('data-pack-size'));
        if (radioSize === size) {
          radio.classList.add('pack-card__radio--active');
        } else {
          radio.classList.remove('pack-card__radio--active');
        }
      });

      // Show/hide promo (6-pack only)
      if (promoEl) {
        promoEl.style.display = size === 6 ? '' : 'none';
      }

      // Only update variant/button if we have data for this pack size
      if (!data) return;

      // Update variant ID for add-to-cart
      if (variantInput) {
        variantInput.value = data.variantId;
        if (!data.available) {
          variantInput.setAttribute('disabled', 'disabled');
        } else {
          variantInput.removeAttribute('disabled');
        }
      }

      // Update sold-out state on button
      if (submitButton) {
        if (!data.available) {
          submitButton.setAttribute('disabled', 'disabled');
          if (addToCartSpan) addToCartSpan.classList.add('hidden');
          if (soldOutSpan) soldOutSpan.classList.remove('hidden');
        } else {
          submitButton.removeAttribute('disabled');
          if (addToCartSpan) addToCartSpan.classList.remove('hidden');
          if (soldOutSpan) soldOutSpan.classList.add('hidden');
        }
      }

      // Update price on the Quick Add button
      var priceEl = cardEl.querySelector('[data-pack-button-price]');
      if (priceEl) {
        priceEl.textContent = data ? formatMoney(data.price) : '';
      }

      // Card links are set server-side via Liquid (card_link_url) and should
      // not be overwritten by the pack selector — they always point to the LP.

      // Swap the product card image to match the selected pack size
      if (cardMediaEl && data.image) {
        // Build srcset with common widths
        var srcsetParts = [165, 360, 533, 720, 940].map(function (w) {
          return data.image.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w';
        });
        cardMediaEl.srcset = srcsetParts.join(', ');
        cardMediaEl.src = data.image;
        if (data.imageAlt) {
          cardMediaEl.alt = data.imageAlt;
        }
      }
    }

    // Attach click handlers to radios
    radios.forEach(function (radio) {
      radio.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var size = parseInt(this.getAttribute('data-pack-size'));
        selectPack(size);
      });
    });

    // Thumbnail gallery: click a thumb to swap the main card image
    var thumbs = cardEl.querySelectorAll('.pack-card__thumb[data-thumb-full]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var fullSrc = this.getAttribute('data-thumb-full');
        var fullAlt = this.getAttribute('data-thumb-alt');
        if (!fullSrc || !cardMediaEl) return;

        // Swap main image src + srcset
        var srcsetParts = [165, 360, 533, 720, 940].map(function (w) {
          return fullSrc.replace(/width=\d+/, 'width=' + w) + ' ' + w + 'w';
        });
        cardMediaEl.srcset = srcsetParts.join(', ');
        cardMediaEl.src = fullSrc;
        if (fullAlt) cardMediaEl.alt = fullAlt;

        // Highlight active thumbnail
        thumbs.forEach(function (t) {
          t.classList.remove('pack-card__thumb--active');
        });
        this.classList.add('pack-card__thumb--active');
      });
    });

      // Make the entire card clickable — navigate to the product page
    // when clicking anywhere except interactive elements (radios, buttons)
    cardEl.style.cursor = 'pointer';
    cardEl.addEventListener('click', function (e) {
      var target = e.target;
      while (target && target !== cardEl) {
        if (target.matches('.pack-card__radio, .pack-card__thumb, .pack-card__thumb img, button, input, .quick-add, .quick-add__submit')) {
          return;
        }
        // Allow clicks on the card product link (and its ::after overlay) to fall through
        if (target.matches('a') && !target.hasAttribute('data-pack-card-link')) {
          return;
        }
        target = target.parentElement;
      }

      // Prevent the natural <a> navigation — we handle it below
      e.preventDefault();

      var link = cardEl.querySelector('[data-pack-card-link]');
      if (link && link.href) {
        var isMobile = window.matchMedia('(max-width: 989px)').matches;
        var isHomepage = window.location.pathname === '/';
        if (isMobile && isHomepage) {
          cardEl.classList.add('is-previewing');
          setTimeout(function () {
            window.location.href = link.href;
          }, 800);
        } else {
          window.location.href = link.href;
        }
      }
    });


    // Initialize to 6-pack (default), fallback to largest available
    var defaultSize = packMap[6] ? 6 : (packMap[4] ? 4 : 2);
    selectPack(defaultSize);
  }

  /**
   * Initialize all pack cards on the page
   */
  function initAll() {
    var cards = document.querySelectorAll('[data-pack-card]');
    cards.forEach(initPackCard);
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Handle Shopify section rendering (theme editor live preview)
  document.addEventListener('shopify:section:load', function () {
    setTimeout(initAll, 100);
  });
})();